import ApiHandler from "./ApiHandler";
import {saveAs} from 'file-saver';

const File = {
  getOne: async (hash) => {
    const response = await ApiHandler.i.auth().get(`/file/${hash}`);
    if (!response) return;
    saveAs(response.url, response.name);
  },
};

export default File;